// import { useGoogleAnalytics } from "../../../../GlobalHooks/web/GoogleAnalytics.hook";
import { useFilters } from "../../../../Components/Filters/Filters.hook";
import { MapIcon } from "shared-components/Components/CustomIcons/MapIcon/web";
import { Button } from "shared-components/Components/Buttons/web";

export const ButtonMapToggle = ({ map, setMap, small = false }) => {
	const { changeFilters } = useFilters();

	if (small) {
		return (
			<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
				onClick={() => {
					let showMap = !map;
					changeFilters({ mapView: showMap });
					setMap(showMap);
				}}>
				<MapIcon />
				<span style={{ height: '20px' }}>{map ? "Lista" : "Mapa"}</span>
			</div>
		)
	}

	return (
		<Button type="secondary"
			onClick={() => {
				let showMap = !map;
				changeFilters({ mapView: showMap });
				setMap(showMap);
			}}>
			<MapIcon />
			{map ? "Ver Listado" : "Ver Mapa"}
		</Button>
	);
};

